<template>
    <section class="performance-collusion-warning-map-container" v-loading="bdLoading">
        <div class="detail-container">
            <div class="text-show-box">
                <div>
                    <div class="info-header-content">
                        <i class="el-icon-back" @click="backToIndex"></i>
                        <span class="info-header-content" @dblclick.self="copyToClip(dispatchNo)">
                            <strong>发车单号:</strong>
                            {{ dispatchNo }}<i class="el-icon-document-copy" @click.stop="copyToClip(dispatchNo)"></i>
                        </span>
                    </div>
                    <div class="info-header-content">
                        <strong>司机：</strong>
                        <i class="el-icon-user el-icon mgr-5"></i>
                        <span @dblclick.self="copyToClip(formData.driver)">{{ formData.driver || '--' }}</span>
                        <i class="el-icon-phone el-icon mg-5"></i>
                        <span @dblclick.self="copyToClip(formData.driverContactWay)">{{ formData.driverContactWay || '--' }}</span>
                    </div>
                    <div class="info-header-content">
                        <strong>经营中心：</strong>{{formData.centerName}}
                    </div>
                </div>
                <div class="mgl-10">
                    <div class="info-header-content">
                        <strong> 服务平台：</strong>{{formData.siteName}}
                    </div>
                    <div class="info-header-content" :class="{'ellipsis-text': isActiveEllipsis}">
                        <strong> 客户：</strong>
                        <el-tooltip
                            class="item"
                            effect="dark"
                            :content="`${formData.customerName || '--'}`"
                            placement="top-start"
                        >
                            <span class="">{{ formData.customerName || '--' }}</span>
                        </el-tooltip>
                    </div>
                </div>
            </div>
            <span class="header-btn-box">
                <div class="btn-box">
                    <span class="legend-Golde-track">高德规划线路</span>
                    <span class="legend-drive-track">司机真实轨迹</span>
                    <el-button @click="refresh" :loading="bdLoading">刷新</el-button>
                </div>
                <div class="select-box">
                    【 轨迹源 】
                    <el-select v-model="trackingType" placeholder="请选择轨迹源" clearable @change="changeSelect">
                        <el-option v-for="item in trackingTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div>
            </span>
        </div>
        <div id="GoldeMap"></div>
        <div class="warning-data-container" :style="{ width: tableBoxShow ? '634px' : '52px' }">
            <div class="warning-table-box" v-show="tableBoxShow">
                <el-tabs v-model="activeName">
                    <el-tab-pane label="待处理" name="pending">
                        <div v-for="(item, index) in warningPendingData" v-show="warningPendingData.length" :key="index" class="table-data-Info">
                            <span class="info-flex-two"><strong>第{{ item.indexName }}次预警：</strong>{{ item.warningTypeName }}</span>
                            <span class="info-flex-two"><strong>预警时间：</strong>{{ item.warningTime }}</span>
                            <span class="info-flex-one"><strong>预警原因：</strong>{{ item.warningReason }}</span>
                            <span class="info-flex-two"><strong>智能拨号时间：</strong>{{ item.virtualDialTime }}</span>
                            <span class="info-flex-two"><strong>智能拨号状态：</strong>{{ item.virtualDialStatusName }}
                                <el-tooltip effect="dark" placement="right">
                                    <div slot="content" v-html="content"></div>
                                    <i class="header-icon el-icon-info"></i>
                                </el-tooltip>
                            </span>
                            <div><el-button v-has="permissionCode.handleBtn" type="primary" @click="handleSubmit(item)">处 理</el-button></div>
                        </div>
                        <div v-show="!warningPendingData.length" class="no-warning-data">暂无待处理数据</div>
                    </el-tab-pane>
                    <el-tab-pane label="已处理" name="process">
                        <div v-for="(item, index) in warningProcessData" v-show="warningProcessData.length" :key="index" class="table-data-Info">
                            <span class="info-flex-two"><strong>第{{ item.indexName }}次预警：</strong>{{ item.warningTypeName }}</span>
                            <span class="info-flex-two"><strong>预警时间：</strong>{{ item.warningTime }}</span>
                            <span class="info-flex-one"><strong>预警原因：</strong>{{ item.warningReason }}</span>
                            <span class="info-flex-two"><strong>预警处理人：</strong>{{ item.warningProcessor }}</span>
                            <span class="info-flex-two"><strong>预警处理时间：</strong>{{ item.warningProcessTime }}</span>
                            <span class="info-flex-two"><strong>智能拨号时间：</strong>{{ item.virtualDialTime }}</span>
                            <span class="info-flex-two"><strong>智能拨号状态：</strong>{{ item.virtualDialStatusName }}
                                <el-tooltip effect="dark" placement="right">
                                    <div slot="content" v-html="content"></div>
                                    <i class="header-icon el-icon-info"></i>
                                </el-tooltip>
                            </span>
                            <span class="info-flex-one"><strong>备 注：</strong>{{ item.remark }}</span>
                        </div>
                        <div v-show="!warningProcessData.length" class="no-warning-data">暂无已处理数据</div>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div class="text-icon-box">
                <div>预警数据处理</div>
                <i :class="tableBoxShow ? 'el-icon-caret-left' : 'el-icon-caret-right'" @click="tableShow"></i>
            </div>
        </div>
        <div class="Golde-first-plan-route" :style="{ width: routeBoxShow ? '560px' : '52px' }">
            <div class="text-icon-box">
                <div>轨迹线路</div>
                <i :class="routeBoxShow ? 'el-icon-caret-right' : 'el-icon-caret-left'" @click="routeShow"></i>
            </div>
            <div>
                <el-tabs v-model="activeNameRoute" type="card">
                    <el-tab-pane label="轨迹列表" name="list">
                        <div class="list-container">
                            <vxe-table show-overflow border :data="locationData" size="mini" height="100%">
                                <vxe-column type="seq" title="序号" width="50" align="center"></vxe-column>
                                <vxe-column field="trackingDate" title="时间" align="center"></vxe-column>
                                <vxe-column
                                    field="trackingLocationName"
                                    :title="'地点(共' + locationData.length + '条)'"
                                    align="center"
                                ></vxe-column>
                                <vxe-column field="speedName" title="速度" width="80" align="center"></vxe-column>
                                <vxe-column field="isAbnormalName" title="异常" width="50" align="center"></vxe-column>
                            </vxe-table>
                        </div>

                    </el-tab-pane>
                    <el-tab-pane label="高德首次规划线路" name="route">
                        <div class="plan-route-box" v-show="routeBoxShow">
                            <div v-for="(step, index) in firstPlanRouteData" :key="index">
                                <div class="step">
                                <div :class="['circle', index === 0 ? 'green' : 'orange']">{{ step.pointTitle }}</div>
                                <div class="content">{{ step.siteAddress }}</div>
                                </div>
                                <div v-if="index < firstPlanRouteData.length - 1" :class="['line', index === 0 ? 'green' : 'orange']"></div>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>

        <div class="refresh-btn-box">
            <el-tooltip effect="dark" content="恢复初始状态" placement="top">
                <i class="el-icon-refresh" @click="setFitView"></i>
            </el-tooltip>
        </div>
        <!-- 处理按钮弹窗 -->
        <HandleDialog
            v-if="dialogCtrl.visible"
            :row-data="dialogCtrl.row"
            @closed="dialogCtrl.visible = false"
            @success="getWarningData"/>
    </section>
</template>
<script>
import bigDataLog from '@/utils/bigDataLog';
import { isExternalHttpWorked } from '@/modules/transport/otp/utils/mapLoader';
import { setupMap, TraceRouteController } from './map';
import { dictWithUrl } from '@/components/lots/api.js';
import { queryByPage, getGoldePoint, getDriverTrack, getWarning, getPlanLine, handleWarningData } from '@/modules/transport/otp/api/collusionWarningMap';
import { convertToCoordinates, transformTrackingData, formateData, formateList, outputArray, formatTotalDataList } from './util';
import HandleDialog from '../collusionWarning/WarningHandle/components/HandleDialog.vue';

const mapController = new TraceRouteController();
export default {
    name: 'collusionWarningMap',
    components: { HandleDialog },
    data () {
        return {
            bdLoading: false,
            tableBoxShow: false,
            routeBoxShow: false,
            activeName: 'pending',
            activeNameRoute: 'list',
            dispatchNo: '',
            driverTrack: [],
            firstPlanRouteData: [],
            warningData: [],
            warningPendingData: [],
            warningProcessData: [],
            goldePlanRoute: [],
            dictData: {},
            content: `触发预警时，系统会拨打语音电话通知司机改善问题。<br/>注意：为避免频繁拨号，系统不会每个预警触发都会进行拨号。`,
            formData: {
                customerName: '',
            },
            locationData: [],
            trackingTypeOptions: [],
            trackingType: '50',
            isActiveEllipsis: false,
            // 按钮权限编码Map
            permissionCode: {
                handleBtn: '/performance/collusion-warning/mapPage/handleBtn'
            },
            dialogCtrl: {
                visible: false,
                row: {}
            }
        };
    },
    created () {
        this.dispatchNo = this.$route.query.dispatchNo;
        this.dispatchNo && this.initPage();
    },
    activated () {
        const { dispatchNo } = this.$route.query;
        if (dispatchNo !== this.dispatchNo) {
            this.dispatchNo = dispatchNo;
            this.dispatchNo && this.initPage();
        }
    },
    methods: {
        async initPage () {
            await this.checkMapResource();
            await dictWithUrl('CHANGE_MONITOR_WARNING_TYPE,DISPATCH_VIRTUAL_DIAL_STATUS,TRACKING_TYPE')
                .then(res => {
                    this.dictData = res.data;
                    this.trackingTypeOptions = outputArray(this.dictData.TRACKING_TYPE);
                });
            const promises = [
                this.getTitle(),
                this.getWarningData(),
                this.getFirstPlanRoute(),
                this.getGoldePlanRoute(),
                this.getDriverRealTrack()
            ];
            await this.getData(promises);
        },
        getData (promises) {
            this.bdLoading = true;
            mapController.clearCover();
            Promise.all(promises)
                .then(() => { })
                .catch(() => { })
                .finally(() => {
                    this.bdLoading = false;
                    const routerList = [...this.driverTrack, ...this.goldePlanRoute];
                    routerList.length && mapController.setRouteData({ routes: routerList });
                });
        },
        async checkMapResource () {
            isExternalHttpWorked().then(worked => {
                if (!worked) {
                    return this.$message.warning('地图加载失败，请检查外网连接是否畅通，并联系IT管理员');
                }
            });
            await this.doSetupMap();
        },
        async doSetupMap () {
            if (!mapController.isSetup()) {
                await setupMap('GoldeMap', mapController);
            }
        },
        getTitle () {
            const param = {
                pageSize: 10,
                pageNo: 1,
                param: { dispatchNo: this.dispatchNo }
            };
            queryByPage(param).then(res => {
                if (res && +res.code === 0) {
                    this.formData = res.data.list[0] || {};
                    this.isActiveEllipsis = this.formData.customerName && this.formData.customerName.split(',').length > 2;
                }
            });
        },
        // 获取预警数据处理
        async getWarningData () {
            const param = { dispatchNo: this.dispatchNo };
            await getWarning(param).then(res => {
                if (res && +res.code === 0) {
                    this.warningData = formateList(res.data || [], this.dictData);
                    this.warningData.length && mapController.setWarningPoint(this.warningData);
                    this.warningPendingData = this.warningData.filter(v => +v.warningStatus === 1);
                    this.warningProcessData = this.warningData.filter(v => +v.warningStatus === 2);
                }
            }).finally(() => { this.tableBoxShow = true; });
        },
        // 获取高德首次规划线路
        async getFirstPlanRoute () {
            const param = { dispatchNo: this.dispatchNo };
            await getPlanLine(param).then(res => {
                if (res && +res.code === 0) {
                    this.firstPlanRouteData = formateData(res.data || []);
                    this.firstPlanRouteData.length && mapController.setPlanLinePoint(this.firstPlanRouteData);
                }
            });
        },
        // 获取高德规划线路
        async getGoldePlanRoute () {
            const param = {
                dispatchNo: this.dispatchNo
            };
            await getGoldePoint(param).then(res => {
                if (res && +res.code === 0) {
                    this.goldePlanRoute = convertToCoordinates(res.data.routeList || [], res.data.mapType);
                }
            });
        },
        // 获取司机真实轨迹
        async getDriverRealTrack () {
            const param = {
                dispatchNo: this.dispatchNo,
                deviceNo: '',
                trackingType: this.trackingType
            };
            await getDriverTrack(param).then(res => {
                if (res && +res.code === 0) {
                    this.driverTrack = transformTrackingData(res.data || []);
                    this.locationData = formatTotalDataList(res.data);
                }
            });
        },
        changeSelect (value) {
            this.trackingType = value;
            const promises = [
                this.getDriverRealTrack()
            ];
            this.getData(promises);
            this.warningData.length && mapController.setWarningPoint(this.warningData);
            this.firstPlanRouteData.length && mapController.setPlanLinePoint(this.firstPlanRouteData);
        },
        handleSubmit (data) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-collusion-warningMap-submit');
            Object.assign(this.dialogCtrl, {
                visible: true,
                row: {
                    id: data.id,
                    warningType: data.warningType,
                    dispatchNo: this.dispatchNo,
                    __warningTypeName__: data.warningTypeName
                }
            });
        },
        refresh () {
            bigDataLog.sendDetailMessageByKey('bigData-btn-collusion-warningMap-refresh');
            this.trackingType = '50';
            const promises = [
                this.getTitle(),
                this.getWarningData(),
                this.getFirstPlanRoute(),
                this.getGoldePlanRoute(),
                this.getDriverRealTrack()
            ];
            this.getData(promises);
        },
        tableShow () {
            bigDataLog.sendDetailMessageByKey('bigData-btn-collusion-warningMap-tableShow');
            this.tableBoxShow = !this.tableBoxShow;
        },
        routeShow () {
            bigDataLog.sendDetailMessageByKey('bigData-btn-collusion-warningMap-routeShow');
            this.routeBoxShow = !this.routeBoxShow;
        },
        setFitView () {
            mapController.setFitView();
        },
        backToIndex () {
            this.$router.push({
                path: `/otp/distribute/collusion-warning`
            });
        },
        copyToClip(txt) {
            var input = document.createElement('input');
            input.setAttribute('value', txt);
            document.body.appendChild(input);
            // 选择对象
            input.select();
            // 执行浏览器复制命令
            document.execCommand('copy');
            document.body.removeChild(input);
            this.$message.success(`‘${input.value}’复制成功`);
        }
    },
    beforeDestroy() {
        mapController.destroy();
    }
};
</script>
<style lang="less" scoped>
@import url('./style.less');
</style>
<style lang="less">
@import url('./map.less');
</style>
